import qs from 'qs';

import { cleanObjectEmptyFields } from './clearObject';

export function createQueryKey(prefix, object = {}) {
  const cleanedObject = cleanObjectEmptyFields(object);
  const stringifiedKeys = qs.stringify(cleanedObject, {
    skipNulls: true,
    sort: (a, b) => a.localeCompare(b)
  });

  return [prefix, stringifiedKeys];
}
